export const brlPrice = (value) => {
  value = value ? parseFloat(value) : parseFloat(0)

  return value.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2
  })
}

export const toCurrency = (value) => {
  value = value ? parseFloat(value) : parseFloat(0)
  return value.toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
}
